import { setSearchIPO } from '../store/slice/masterSlice';
import { Images, useState, useEffect, useRef, icons, useDispatch, useNavigate, useLocation } from '../utils/npm'; // Import icons
const { selectIcon } = Images;
const { IoCaretDownSharp } = icons
function FilterTypesInner({ onFilterChange, selectedFilter }) {
  // Initialize dropdownTitle based on parent value
  const [dropdownTitle, setDropdownTitle] = useState(selectedFilter?.ipoName);
  const [menuShow, setMenuShow] = useState('');
  const dropdownRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setDropdownTitle(selectedFilter?.ipoName);
  }, [selectedFilter]);

  const handleFilterClick = (filterType, filterName) => {
    setDropdownTitle(filterName);
    setMenuShow('');
    onFilterChange({ ipoType: filterType, ipoName: filterName });

    // -------------------------------------- code is only for path chnages -------------------------------------------------------
    const pathSegments = location.pathname.split("/");
    // searchParams.delete("ipo-type");
    const searchParams = new URLSearchParams(location.search);
    let newFilterValue = `${filterType || "all_ipo"}-${pathSegments[1]}-ipo`;
    // if (searchParams.has("ipo-type")) {
      // searchParams.set("ipo-type", newFilterValue);
    // } else {
    //   searchParams.append("ipo-type", newFilterValue);
    // }
    // navigate(`${location.pathname}?${searchParams.toString()}`, { replace: true });
  };

  const handleMainBoard = () => {
    setMenuShow(menuShow === '' ? 'open_filter' : ''); // Toggle menu visibility
  };

  useEffect(() => {

    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setMenuShow(''); // Close the dropdown
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <li className="nav-item dropdown home-filter-dropdown " ref={dropdownRef}>
      <a
        className="nav-link dropdown-toggle filter-inner-sec"
        role="button"
        onClick={handleMainBoard}
      >
        <img src={selectIcon} alt="Filter" className="filter-icon" />
        <span
          className={`dropdown-title ${dropdownTitle === 'sme' ? 'uppercase' : (dropdownTitle === 'All IPOs' ? "" : 'capitalize')
            }`}
        >
          {dropdownTitle}
        </span>
        <span>
          <IoCaretDownSharp className="text-xs down_arrow_filter" />
        </span>
      </a>
      <ul className={`dropdown-menu ${menuShow}`}>
        <li>
          <a
            className={`dropdown-item cursor-pointer ${selectedFilter.ipoName === 'MainBoard' ? 'active' : ''
              }`}
            onClick={() => handleFilterClick('mainboard', 'MainBoard')}
          >
            MainBoard
          </a>
        </li>
        <li>
          <a
            className={`dropdown-item cursor-pointer ${selectedFilter.ipoName === 'SME' ? 'active' : ''
              }`}
            onClick={() => handleFilterClick('sme', 'SME')}
          >
            SME
          </a>
        </li>
        <li>
          <hr className="dropdown-divider" />
        </li>
        <li>
          <a
            className={`dropdown-item cursor-pointer ${selectedFilter.ipoName === 'All IPOs' ? 'active' : ''
              }`}
            onClick={() => handleFilterClick('', 'All IPOs')}
          >
            All IPOs
          </a>
        </li>
      </ul>
    </li>
  );

}

export default FilterTypesInner;
